import { Component, Inject, OnInit } from "@angular/core";
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { BehaviorSubject } from "rxjs";
import { MmTranslateService } from "../../../mm-translate.service";

export interface BlockingDialogData {
  header$?: BehaviorSubject<string>;
  body$?: BehaviorSubject<string>;
  totalFilesAmount$?: BehaviorSubject<number>;
  processedFilesAmount$?: BehaviorSubject<number>;
  showCancel$?: BehaviorSubject<boolean>;
  progressText$?: BehaviorSubject<string>;
  recordsText$?: BehaviorSubject<string>;
}

@Component({
  selector: 'mydocma-mm-mm-fault-download-progress-dialog',
  templateUrl: './mm-fault-download-progress-dialog.component.html',
  styleUrls: ['./mm-fault-download-progress-dialog.component.css']
})
export class MmFaultDownloadProgressDialogComponent {

  translations = {
    cancel: '',
    close: ''
  };
  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: BlockingDialogData,
    public dialogRef: MatDialogRef<MmFaultDownloadProgressDialogComponent>,
    public readonly translateService: MmTranslateService,){}


  ngOnInit(): void{
    this.loadTranslations();
  }

  private loadTranslations(): void {
    this.translateService.get([
      'MM.general.button.cancel',
      'MM.general.button.close',
    ]).subscribe(res => {
      this.translations.cancel = res['MM.general.button.cancel'];
      this.translations.close = res['MM.general.button.close']; 
    });
  }

  public onCancel(){
    this.dialogRef.close(true);
  }
}
